import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function InsurancePage() {
  return (
    <SectionLayout title="Insurance">
      {/* Insurance content will go here */}
    </SectionLayout>
  );
} 